import * as angular from 'angular';
import {
    getCityStateAndZipcode,
    getFormattedBelongingsCoverageAmount,
    getFormattedGeneralDeductibleAmount,
    getFormattedHomeCoverageAmount,
    getFullAddress,
    getStreetAddress
} from 'common/source/utilities/policyInfoDisplay';
import { getCoverageSref, getOverviewSref, getPaymentsSref } from 'components/navigation/shared/states';
import { getPolicyTermText } from '../../shared';
import { getCallToActionMapping, getDerivedPaymentStatus, shouldShowCta } from 'utilities/paymentsHelper';

interface PoliciesPolicyCardController extends angular.IStrictController {
    policyInfo: CustomerPolicyInfo;
    policyIndex: RoutePolicyIndex;

    policyNumber: string;
    policyTerm: string;
    streetAddress: string;
    cityStateAndZipcode: string;
    homeCoverageAmount: string;
    belongingsCoverageAmount: string;
    generalDeductibleAmount: string;
    fullAddress: string;

    paymentsSref: string;
    coverageSref: string;
    overviewSref: string;

    showCtaButton: boolean;
    derivedPaymentStatus: DerivedPaymentStatus | undefined;
    hasCta: boolean;
    callToActionCopy: string;
    ctaSref: string;
}

export function policiesPolicyCardController(this: PoliciesPolicyCardController, $element: angular.IAugmentedJQuery) {
    'ngInject';

    this.$onInit = () => {
        this.policyNumber = this.policyInfo.policy_number;
        this.policyTerm = getPolicyTermText(this.policyInfo);

        this.homeCoverageAmount = getFormattedHomeCoverageAmount(this.policyInfo);
        this.belongingsCoverageAmount = getFormattedBelongingsCoverageAmount(this.policyInfo);
        this.generalDeductibleAmount = getFormattedGeneralDeductibleAmount(this.policyInfo) || '';

        this.streetAddress = getStreetAddress(this.policyInfo);
        this.fullAddress = getFullAddress(this.policyInfo);
        this.cityStateAndZipcode = getCityStateAndZipcode(this.policyInfo);

        this.paymentsSref = getPaymentsSref(this.policyIndex);
        this.coverageSref = getCoverageSref(this.policyIndex);
        this.overviewSref = getOverviewSref(this.policyIndex);

        this.showCtaButton = false;
        this.derivedPaymentStatus = getDerivedPaymentStatus(this.policyInfo);
        this.hasCta = shouldShowCta(this.policyInfo, 'policyList');
        if (this.hasCta) {
            $element.addClass('warning');
            const callToAction = getCallToActionMapping(this.policyInfo);
            if (callToAction) {
                this.callToActionCopy =
                    typeof callToAction.copy === 'string' ? callToAction.copy : callToAction.copy(this.policyInfo);
                if (callToAction.ctaSref) {
                    this.ctaSref = callToAction.ctaSref(this.policyIndex);
                    this.showCtaButton = true;
                }
            }
        }
    };
}
